import { Box, MenuItem, Select } from "@mui/material";
import { useState } from "react";
import { useStyles } from "../styles";

const CustomSelectTag = ({ data, index, setValue, disable }) => {
  const classes = useStyles();

  const allTees = [
    { id: 1, label: "White", value: "white" },
    { id: 2, label: "Yellow", value: "yellow" },
    { id: 3, label: "Blue", value: "blue" },
    { id: 4, label: "Black", value: "black" },
  ];

  const calculateHighestTee = (arr) => {
    let tempArr = [];

    for (let a = 0; a < arr.length; a++) {
      tempArr.push(arr[a][arr[a].default_tee]);
      arr[a].advantage = true;
    }

    let indexOfMaxVal = tempArr.indexOf(Math.max(...tempArr));

    arr[indexOfMaxVal].advantage = false;

    setValue(arr);
  };

  const handleChangeTee = (e) => {
    let tempArr = [...data];

    tempArr[index].default_tee = e.target.value;

    calculateHighestTee(tempArr);
  };

  return (
    <Box
      className={classes.textBoxMain}
      sx={{
        backgroundColor:
          data[index]?.default_tee === "yellow"
            ? "#FFC700"
            : data[index]?.default_tee === "white"
            ? "#C4C4C4"
            : data[index]?.default_tee === "black"
            ? "#000000"
            : data[index]?.default_tee,
      }}
    >
      <Box className={classes.numberBox}>
        {data[index] && data[index][data[index].default_tee]}
      </Box>
      <Select
        variant="standard"
        disableUnderline
        disabled={disable}
        value={data[index] ? data[index]?.default_tee : "White"}
        defaultValue=""
        onChange={handleChangeTee}
        sx={{
          fontSize: { md: "11px", xl: "13px" },
          padding: 0,
          paddingLeft: 0.2,
          color: "#fff",
          fontWeight: 700,
          letterSpacing: ".25px",
          // backgroundColor: data[index] ? data[index].default_tee : "white",
          width: "70%",
          "::before": { display: "none" },
          ":focus": { backgroundColor: "transparent !important" },
          ":focus-within": { background: "transparent !important" },
        }}
      >
        {allTees.map(({ id, value, label }) => (
          <MenuItem key={id} value={value}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

export default CustomSelectTag;
